import { type HttpClient } from '../useHttpClient';

export type RequestNudgesReportEmailParams = {
  destinationEmailAddresses: string[];
};

export const fetchRequestNudgesReportEmail =
  (httpClient: HttpClient) =>
  async (params: RequestNudgesReportEmailParams) => {
    const response = await httpClient.api('/admin/nudges/report', {
      method: 'POST',
      body: JSON.stringify(params),
    });

    return response.json as Response;
  };
